import { gql } from 'apollo-angular';

export const SetFoodForOrderDocument = gql`
  mutation setFoodForOrder($input: UpdateOrderFoodInput!) {
    setFoodForOrder(input: $input) {
      id
      valueToPay
      originalValueToPay
      orderFood {
        items {
          quantity
          food {
            priceBrutto
          }
        }
      }
    }
  }
`;
